<template>
  <UsagePerSolution />
</template>
<script setup lang="ts">
import UsagePerSolution from "./UsagePerSolution.vue";
</script>
